<div class="breadcrumb-area">
	<h1>Reporte de Cuentas por Pagar</h1>
</div>
<div class="card mb-3" id="billPayableGeneralBalanceReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==1?0:1">
		<h3>Antigüedad de Saldos y Reportería</h3>
		<h3><i [ngClass]="selectedReport==1?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==1">
		<div class="row">
			<div class="col-sm-3">
				<div class="form-group">
					<label for="date4" class="form-label">Fecha:</label>
					<input type="date" [(ngModel)]="endDate" id="date4" name="date4" class="form-control">
				</div>
			</div>
			<div class="col-sm-4 form-group">
				<label for="warehouse" class="form-label">Bodega:</label>
				<select name="warehouse" [(ngModel)]="warehouse" id="warehouse" class="form-select">
					<option value="0">Todas las bodegas</option>
					<option *ngFor="let warehouse of warehouses" value="{{warehouse.id}}">{{warehouse.name}}</option>
				</select>
			</div>
			<div class="col-sm-3">
				<div class="form-group">
					<label for="filterOldAccountReport" class="form-label">Búsqueda</label>
					<input type="text" id="filterOldAccountReport" placeholder="Buscar en saldos generales"
						name="filterOldAccountReport" class="form-control"
						[(ngModel)]="filterWordReport1"
						(input)="onInputChangeReport1($event)">
				</div>
			</div>
			<div class="col-sm-2 download-buttons">
				<button class="btn btn-success" (click)="getBillReceivableGeneralBalanceReport('excel')"
					data-bs-toggle="tooltip" title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getBillReceivableGeneralBalanceReport('pdf')"
					data-bs-toggle="tooltip" title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" (click)="getBillReceivableGeneralBalanceReport('json')"
					data-bs-toggle="tooltip" title="Ver Reporte"><i class="fa fa-eye"></i></button>
			</div>
			<ng-container *ngIf="paginationAccountsReport1.total.length > 0">
				<div class="table-responsive">
					<table style="margin-bottom: 0px !important;" class="table table-striped">
						<thead>
							<tr>
								<th>Código</th>
								<th>Proveedor</th>
								<th>Saldo</th>
								<th>1 a 30 días</th>
								<th>31 a 60 días</th>
								<th>61 a 90 días</th>
								<th>91 o más días</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let vendor of paginationAccountsReport1.filter">
								<td>{{vendor.code}}</td>
								<td>{{vendor.name}}</td>
								<td>{{vendor.balance}}</td>
								<td>{{vendor.total30?vendor.total30:0}}</td>
								<td>{{vendor.total60?vendor.total60:0}}</td>
								<td>{{vendor.total90?vendor.total90:0}}</td>
								<td>{{vendor.totaln?vendor.totaln:0}}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom *ngIf="paginationAccountsReport1"
					[elements]="paginationAccountsReport1"></app-pagination-custom>
			</ng-container>
		</div>
	</div>
</div>

<div class="card mb-3" id="billPayableList">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==2?0:2">
		<h3>Control de Saldos por Proveedores y Reportería</h3>
		<h3><i [ngClass]="selectedReport==2?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==2">
		<div class="row">
			<div class="col-sm-10">
				<div class="form-group">
					<label for="filterBalanceByClientReport" class="form-label">Búsqueda</label>
					<input type="text" id="filterBalanceByClientReport" placeholder="Buscar Proveedor"
						name="filterBalanceByClientReport" class="form-control"
						[(ngModel)]="filterWordReport2"
						(input)="onInputChangeReport2($event)">
				</div>
			</div>
			<div class="col-sm-2 download-buttons">
				<button class="btn btn-success" (click)="getBillPayableList('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getBillPayableList('pdf')" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" (click)="getBillPayableList('json')" data-bs-toggle="tooltip"
					title="Ver Reporte"><i class="fa fa-eye"></i></button>
			</div>
			<ng-container *ngIf="paginationAccountsReport2.total.length > 0">
				<div class="table-responsive">
					<table style="margin-bottom: 0px !important;" class="table table-striped">
						<thead>
							<tr>
								<th>Código</th>
								<th>NIT</th>
								<th>Proveedor</th>
								<th>Saldo</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let client of paginationAccountsReport2.filter">
								<td>{{client.code}}</td>
								<td>{{client.nit}}</td>
								<td>{{client.name}}</td>
								<td>{{client.balance}}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom *ngIf="paginationAccountsReport2.total.length > 0"
					[elements]="paginationAccountsReport2"></app-pagination-custom>
			</ng-container>
		</div>
	</div>
</div>

<!-- <div class="card mb-3" id="StatementReportGeneral">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==3?0:3">
		<h3>Estado de cuenta CxP General</h3>
		<h3><i [ngClass]="selectedReport==3?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==3">
		<div class="row">
			<div class="col-sm-5">
				<div class="form-group">
					<label for="startDate5" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate5" name="startDate5" class="form-control">
				</div>
			</div>
			<div class="col-sm-5">
				<div class="form-group">
					<label for="date5" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="date5" name="date5" class="form-control">
				</div>
			</div>
			<div class="col-sm-2 download-buttons">
				<button class="btn btn-success" (click)="getStatementReportGeneral('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
			</div>
		</div>
	</div>
</div> -->

<div class="card mb-3" id="StatementReportGeneral">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==4?0:4">
		<h3>Estado de cuenta CxP por Proveedor</h3>
		<h3><i [ngClass]="selectedReport==4?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==4">
		<div class="row">
			<div class="col-sm-5">
				<div class="form-group">
					<label for="startDate3" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate3" name="startDate3" class="form-control">
				</div>
			</div>
			<div class="col-sm-5">
				<div class="form-group">
					<label for="endDate3" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate3" name="endDate3" class="form-control">
				</div>
			</div>
			<div>
				<div>
					<div class="form-group">
						<label for="client-input" class="form-label">Proveedor</label>
						<div class="input-group input-group-sm" style="margin-bottom: 1em;">
							<app-input-autocomplete [ruleToDisabled]="clients.length == 0" [allBorderRadius]="true"
							[inputs]="client" [placeholder]="'Ingresa el nit o el nombre de un proveedor'"
							[filterElements]="client.filterElements" [typeElements]="'client'" (inputMethod)="writeClient()"
							(changeStatus)="selectClient($event.filterElement,1)" [custom]="true">
							<ng-template #itemsTemplate let-filter>
								<div items>
								<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
									{{filter.name}}</h5>
								<span style="color: white;">NIT: <b>{{filter.nit}}</b></span>
								</div>
							</ng-template>
							</app-input-autocomplete>
						</div>
					</div>
				</div>
			</div>
			<div class="col-sm-2 download-buttons">
				<button class="btn btn-success" (click)="getStatementReportFilter('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
			</div>
		</div>
	</div>
</div>

